import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import connectToStores from 'fluxible-addons-react/connectToStores';
import InventoryRecord from '../../models/InventoryRecord';
import Customer from '../../models/Customer';
import OrderItem from '../../models/OrderItem';
import shallowCompare from '../../lib/shallowCompare';
import Select from '../Select';
import ZipCodeModal from '../ZipCodeModal';
import ShoppingCartActions from '../../actions/ShoppingCartActions';
import ShoppingCartStore from '../../stores/ShoppingCartStore';
import { RequestStates } from '../../stores/PaginatedStore';
import styles from './index.sass';
import MinusPng from '../images/quantity_decrease.png';
import MinusSvg from '../images/quantity_decrease.svg';
import PlusPng from '../images/quantity_increase.png';
import PlusSvg from '../images/quantity_increase.svg';
import TrashcanPng from '../images/trashcan.png';
import TrashcanSvg from '../images/trashcan.svg';

const QuantityOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24];

class QuantitySelector extends React.Component {
  static contextTypes = {
    executeAction : React.PropTypes.func,
    getUserAgent: React.PropTypes.func
  };

  static propTypes = {
    className: React.PropTypes.string,
    showBuyButton: React.PropTypes.bool,
    navigateToBagOnSuccess: React.PropTypes.bool,
    showSelectRemoveOption: React.PropTypes.bool,
    item: React.PropTypes.instanceOf(OrderItem),
    inventoryRecord: React.PropTypes.instanceOf(InventoryRecord).isRequired,
    customer: React.PropTypes.instanceOf(Customer).isRequired,
    storeId: React.PropTypes.string.isRequired
  };

  static defaultProps = {
    className: '',
    showBuyButton: false,
    navigateToBagOnSuccess: true,
    showSelectRemoveOption: false
  };

  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
    this.updateQuantity = _.debounce(this._updateQuantity, 500);
  }

  getStateFromProps(props) {
    let item = null;
    if(props.shoppingCart) {
      item = props.shoppingCart.findItemByInventoryRecordId(props.inventoryRecord.id);
    }
    let quantityInputStyle = 'select';
    if(item && -1 === QuantityOptions.indexOf(item.quantity)) {
      quantityInputStyle = 'input';
    }
    return {
      showZipCodeModal: false,
      loading: props.shoppingCartRequestStatus === RequestStates.Loading,
      quantity: item ? item.quantity : 1,
      quantityShakeAnimation: false,
      item,
      quantityInputStyle
    };
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.shoppingCart !== nextProps.shoppingCart || this.props.inventoryRecord !== nextProps.inventoryRecord) {
      this.setState(this.getStateFromProps(nextProps));
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.quantityInputStyle === 'input' && prevState.quantityInputStyle === 'select') {
      let elem = ReactDOM.findDOMNode(this.refs.quantityInput);
      elem.focus();
      if(elem.setSelectionRange) {
        let len = elem.value * 2;
        setTimeout(() => {
          elem.setSelectionRange(len, len);
        }, 1);
      } else {
        elem.value = elem.value;
      }
    }
  }

  _updateQuantity(quantity) {
    if(quantity === this.state.item.quantity) {return;}
    if(quantity === 0) {return this.removeFromCart();}
    this.setState({loading: true});
    this.context.executeAction(ShoppingCartActions.updateItem, {
      store_id : this.props.storeId,
      item_id  : this.state.item.id,
      quantity : quantity,
      inventoryRecord: this.props.inventoryRecord,
      navigateToBagOnSuccess: !!quantity && this.props.navigateToBagOnSuccess
    });
  }

  addToCart() {
    this.setState({loading: true});
    this.context.executeAction(ShoppingCartActions.addItem, {
      store_id: this.props.storeId,
      inventory_record_id: this.props.inventoryRecord.id,
      quantity: this.state.quantity,
      inventoryRecord: this.props.inventoryRecord,
      navigateToBagOnSuccess: this.props.navigateToBagOnSuccess
    });
  }

  removeFromCart() {
    this.setState({loading: true});
    this.context.executeAction(ShoppingCartActions.removeItem, {
      store_id: this.props.storeId,
      item_id  : this.state.item.id,
      inventoryRecord: this.props.inventoryRecord,
      navigateToBagOnSuccess: false
    });
  }

  handleOnClickBuyButton(e) {
    let customer = this.props.customer;
    if(!customer || !customer.preferences.zip_code) {
      this.setState({showZipCodeModal: true});
    } else if(!this.state.item) {
      this.addToCart();
    } else {
      this._updateQuantity(this.state.quantity);
    }
  }

  handleOnClickLessButton(e) {
    let quantity = this.state.quantity - 1;
    if(quantity < 0) {return;}
    this.setState({quantity});
    if(!this.props.showBuyButton) {
      this.updateQuantity(quantity);
    }
  }

  handleOnClickMoreButton(e) {
    let quantity = this.state.quantity + 1;
    let maxPurchaseQuantity = this.state.item ? this.state.item.inventory_record.max_purchase_quantity : 24;
    if(quantity > maxPurchaseQuantity) {
      this.setState({quantityShakeAnimation: true});
      setTimeout(() => {
        this.setState({quantityShakeAnimation: false});
      }, 100);
      return;
    }
    this.setState({quantity});
    if(!this.props.showBuyButton) {
      this.updateQuantity(quantity);
    }
  }

  handleOnCloseZipCodeModal(zipCodeAdded) {
    this.setState({showZipCodeModal: false});
    if(!zipCodeAdded) {return;}
    this.addToCart();
  }

  handleOnChangeQuantityInput(e) {
    let value = e.target.value.replace(/\D/g, '');
    value = value ? parseInt(value) : '';
    this.setState({quantity: value});
  }

  handleOnBlurQuantityInput(e) {
    this._updateQuantity(this.state.quantity);
  }

  handleOnKeyDownQuantityInput(e) {
    if(e.which === 13) {
      this._updateQuantity(this.state.quantity);
    }
  }

  handleOnChangeQuantitySelect(val) {
    if(val === 'More') {
      this.setState({quantityInputStyle: 'input'});
    } else if(val === 'Remove') {
      this.removeFromCart();
    } else {
      val = parseInt(val);
      this.setState({quantity: val});
      if(!this.props.showBuyButton) {
        this._updateQuantity(val);
      }
    }
  }

  renderZipCodeModal() {
    if(!this.state.showZipCodeModal) {return null;}
    let zipCodeModalProps = {
      onClose: this.handleOnCloseZipCodeModal.bind(this)
    };
    return <ZipCodeModal {...zipCodeModalProps} />;
  }

  renderInput() {
    let { inventoryRecord } = this.props;
    if(inventoryRecord.availability === 'sold_out' || inventoryRecord.availability === 'unavailable') {
      return null;
    }
    let useragent = this.context.getUserAgent();
    if(useragent.isMobile || this.state.quantityInputStyle === 'input') {
      let classes = styles.quantityInput;
      if(this.props.alert && this.props.alert.type === 'QuantityViolation') {
        classes += ` ${styles.invalid}`;
      }
      if(this.state.quantityShakeAnimation) {
        classes += ` ${styles.shake}`;
      }
      let quantityInputProps = {
        className: classes,
        ref: 'quantityInput',
        value: this.state.quantity,
        disabled: useragent.isMobile,
        placeholder: 'Quantity',
        onChange: this.handleOnChangeQuantityInput.bind(this),
        onBlur: this.handleOnBlurQuantityInput.bind(this),
        onKeyDown: this.handleOnKeyDownQuantityInput.bind(this)
      };
      return (
        <div className={styles.quantityButtons}>
          <input {...quantityInputProps} />
          <button className={styles.lessButton} onClick={this.handleOnClickLessButton.bind(this)}>
            <img src={MinusPng} srcSet={MinusSvg} />
          </button>
          <button className={styles.moreButton} onClick={this.handleOnClickMoreButton.bind(this)}>
            <img src={PlusPng} srcSet={PlusSvg} />
          </button>
        </div>
      );
    }
    let quantitySelectProps = {
      className: styles.quantitySelect,
      value: this.state.quantity.toString(),
      onChange: this.handleOnChangeQuantitySelect.bind(this)
    };
    let maxPurchaseQuantity = inventoryRecord.max_purchase_quantity;
    let quantityOptions = [];
    QuantityOptions.forEach((n) => {
      if(n <= maxPurchaseQuantity) {
        quantityOptions.push(n.toString());
      }
    });
    if(maxPurchaseQuantity >= 12) {
      quantityOptions.push('More');
    }
    if(this.props.showSelectRemoveOption && this.state.item) {
      quantityOptions.splice(0,0,'Remove');
    }
    return (
      <Select {...quantitySelectProps}>
        {_.map(quantityOptions, (val) => {
          return <option key={val} value={val}>{val}</option>;
        })}
      </Select>
    );
  }

  renderButton() {
    let { inventoryRecord, showBuyButton } = this.props;
    let { item, quantity, loading } = this.state;
    if(!showBuyButton) {return null;}

    let buttonProps = {
      className: styles.buyButton,
      onClick: this.handleOnClickBuyButton.bind(this),
    };
    let availability = inventoryRecord.availability;
    let buttonContent;
    if(loading) {
      buttonProps.disabled = true;
      buttonContent = <span className="loading-spinner--white" />;
    } else if(availability === 'sold_out') {
      buttonProps.disabled = true;
      buttonProps.className += ` ${styles.soldOut}`;
      buttonContent = 'Sold out';
    } else if(availability === 'unavailable') {
      buttonProps.disabled = true;
      buttonContent = 'Unavailable';
      buttonProps.className += ` ${styles.unavailable}`;
    } else if(item && quantity !== item.quantity) {
      buttonContent = 'Update quantity';
    } else if(item) {
      buttonContent = 'In bag';
      buttonProps.disabled = true;
    } else {
      buttonContent = 'Add to bag';
    }

    return <button {...buttonProps}>{buttonContent}</button>;
  }

  render() {
    return (
      <div className={`${styles.quantitySelector} ${this.props.className} ${this.props.showBuyButton ? styles.flexLayout : ''}`}>
        {this.renderInput()}
        {this.renderButton()}
        {this.renderZipCodeModal()}
      </div>
    );
  }
}

QuantitySelector = connectToStores(QuantitySelector, [ShoppingCartStore], (context, props) => {
  let storeId = props.storeId;
  let shoppingCartStore = context.getStore(ShoppingCartStore);
  let shoppingCart = shoppingCartStore.getShoppingCartByStoreId(storeId);
  return {
    shoppingCart,
    shoppingCartError: shoppingCartStore.getErrorByStoreId(storeId),
    shoppingCartRequestStatus: shoppingCartStore.getRequestStatusByStoreId(storeId)
  };
});

export default QuantitySelector;



// WEBPACK FOOTER //
// banquet/components/QuantitySelector/index.js